export default defineNuxtPlugin((nuxtApp) => {
    const i18n = nuxtApp.vueApp.config.globalProperties.$i18n;

    if (!i18n) {
        console.error('Vue I18n instance not found');
        return;
    }

    // Called right after a new locale has been set
    nuxtApp.hook('i18n:localeSwitched', ({ oldLocale, newLocale }) => {
        const newDir = newLocale === 'fa' ? 'rtl' : 'ltr';
        document.querySelector('html')?.setAttribute('dir', newDir);
    });

    // Initial setup
    const currentLocale = i18n.locale;
    const currentDir = currentLocale === 'fa' ? 'rtl' : 'ltr';
    document.querySelector('html')?.setAttribute('dir', currentDir);
});
